import Vue from 'vue';

const user = Vue.observable({
  uid: null,
  user: {
    id: null,
    userName: null,
    displayName: null,
    companyName: null,
    email: null
  },
  apiToolAccess: 1,
  groupIds: []
});

export {user};

export function setUser(userData) {
  const {uid = null, api_tool_access = null, groupIds = []} = userData;
  const {id = null, user_name = null, display_name = null, company_name = null, email = null} = userData?.user || {};
  user.uid = uid;
  user.apiToolAccess = api_tool_access,
  user.groupIds = groupIds;
  user.user.id = id;
  user.user.userName = user_name;
  user.user.displayName = display_name;
  user.user.companyName = company_name;
  user.user.email = email;
}

export function getUserProfile() {
  if (!user.uid) {
    return null;
  }
  const {id, user_name, display_name, company_name, email} = user.user;
  return {id, user_name, display_name, company_name, email};
}

export function isLoggedIn() {
  return !!user.uid;
}

export function hasDataToolAccess() {
  if (!user.uid) {
    return false;
  }
  return !!user.apiToolAccess;
}

export function isAdmin() {
  if (!user.uid) {
    return false;
  }
  return user.groupIds.includes(2);
}

export function isPaidUser() {
  if (!user.uid) {
    return false;
  }
  return !isAdmin() && user.groupIds.includes(7);
}

export function isFreeLimitedUser() {
  if (!user.uid) {
    return false;
  }
  return !isAdmin() && user.groupIds.includes(8);
}

export function isFreeUser() {
  if (!user.uid) {
    return false;
  }
  return user.groupIds.includes(6);
}

export function isToolAdmin() {
  if (!user.uid) {
    return false;
  }
  return user.groupIds.includes(5);
}

export function isToolUser() {
  if (!user.uid) {
    return false;
  }
  return user.groupIds.includes(4);
}

export function isGuest() {
  if (!user.uid) {
    return false;
  }
  return user.groupIds.length === 1 && user.groupIds.includes(1);
}